import { gql, useLazyQuery } from "@apollo/client";
import { useCallback } from "react";

export const MATCH_BRAND_BY_NAME = gql`
  query matchBrandByName($query: String!) {
    matchBrandByName(query: $query) {
      name
      name_kr
    }
  }
`;

/**
 * 검색어가 브랜드명과 매칭되는지 확인하는 hook
 * @returns {function(string): Promise<{name: string, name_kr: string}|null>}
 */
export default function useMatchBrandByName() {
  const [fetchMatchBrand] = useLazyQuery(MATCH_BRAND_BY_NAME, {
    fetchPolicy: "network-only",
  });

  const checkBrandExist = useCallback(async (query) => {
    try {
      const { data } = await fetchMatchBrand({ variables: { query } });
      return data?.matchBrandByName || null;
    } catch {
      return null;
    }
  }, [fetchMatchBrand]);

  return checkBrandExist;
}
